// client/src/utils/flattenMergeTags.js

export const flattenMergeTagsForUnlayer = (groupedTags) => {
  const flat = {};

  Object.values(groupedTags).forEach(group => {
    Object.entries(group).forEach(([key, tag]) => {
      flat[key] = tag;
    });
  });

  return flat;
};
